/* Frete na página de produto — Sul Etiquetas (ago/2026)
   Estimativa automática pela região do visitante (IP) + cálculo exato por CEP.
   Tudo degrada em silêncio: se a API ou a geolocalização falharem, some o texto
   automático e o cliente ainda pode digitar o CEP. */
(function () {
  'use strict';

  var MOEDA = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var CHAVE_CEP = 'sul:cep';

  function dinheiro(v) {
    return v > 0 ? MOEDA.format(v) : 'Grátis';
  }

  function comTempo(url, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms || 15000);
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, dados: j }; }); })
      .finally(function () { clearTimeout(t); });
  }

  function varianteAtual(box) {
    // o seletor de variante atualiza o input escondido do formulário de compra
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    return box.dataset.variant;
  }

  function prazoTexto(dias) {
    if (!dias && dias !== 0) return '';
    return dias === 1 ? '1 dia útil' : dias + ' dias úteis';
  }

  function pintarLista(alvo, dados) {
    var d = dados.destino || {};
    var onde = (d.cidade ? d.cidade + '/' : '') + (d.uf || '');
    if (!dados.opcoes || !dados.opcoes.length) {
      alvo.innerHTML = '<span class="frete-box__erro">Não encontramos frete para ' + onde + '. Confira o CEP.</span>';
      return;
    }
    var html = '<ul class="frete-lista">';
    dados.opcoes.forEach(function (o) {
      html +=
        '<li><span class="frete-lista__nome">' + o.nome +
        '<span class="frete-lista__prazo">' + prazoTexto(o.prazo_dias) + '</span></span>' +
        '<span class="frete-lista__preco">' + dinheiro(o.preco) + '</span></li>';
    });
    html += '</ul>';
    if (onde) html += '<div class="text--xsmall text--subdued" style="margin-top:6px">Entrega em ' + onde + '</div>';
    alvo.innerHTML = html;
  }

  function estimativaAutomatica(box) {
    var alvo = box.querySelector('[data-frete-auto]');
    var api = (box.dataset.api || '').replace(/\/+$/, '');
    if (!alvo || !api) return;

    fetch('https://ipwho.is/?fields=success,region_code,city')
      .then(function (r) { return r.json(); })
      .then(function (g) {
        if (!g || !g.success || !g.region_code) return;
        var url = api + '/api/frete?variant=' + varianteAtual(box) +
          '&uf=' + encodeURIComponent(g.region_code) +
          (g.city ? '&cidade=' + encodeURIComponent(g.city) : '');
        return comTempo(url).then(function (r) {
          if (!r.ok || !r.dados || !r.dados.mais_barato) return;
          var b = r.dados.mais_barato;
          alvo.textContent =
            'sua região (' + (g.city ? g.city + '/' : '') + g.region_code + '): a partir de ' +
            dinheiro(b.preco) + (b.prazo_dias ? ' em ' + prazoTexto(b.prazo_dias) : '');
        });
      })
      .catch(function () {});
  }

  function ligar(box) {
    if (box.dataset.freteReady === '1') return;
    box.dataset.freteReady = '1';

    var api = (box.dataset.api || '').replace(/\/+$/, '');
    var form = box.querySelector('[data-frete-form]');
    var campo = box.querySelector('[data-frete-cep]');
    var alvo = box.querySelector('[data-frete-resultado]');

    // máscara simples 00000-000
    campo.addEventListener('input', function () {
      var v = campo.value.replace(/\D/g, '').slice(0, 8);
      campo.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
    });

    try {
      var salvo = localStorage.getItem(CHAVE_CEP);
      if (salvo) campo.value = salvo;
    } catch (e) {}

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cep = campo.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        alvo.innerHTML = '<span class="frete-box__erro">Digite um CEP com 8 números.</span>';
        return;
      }
      try { localStorage.setItem(CHAVE_CEP, campo.value); } catch (err) {}
      alvo.textContent = 'Calculando...';

      comTempo(api + '/api/frete?variant=' + varianteAtual(box) + '&cep=' + cep)
        .then(function (r) {
          if (!r.ok) {
            var msg = r.dados && r.dados.error === 'cep_inexistente'
              ? 'CEP não encontrado. Confira os números.'
              : 'Não consegui calcular agora. Tente de novo em instantes.';
            alvo.innerHTML = '<span class="frete-box__erro">' + msg + '</span>';
            return;
          }
          pintarLista(alvo, r.dados);
        })
        .catch(function () {
          alvo.innerHTML = '<span class="frete-box__erro">Não consegui calcular agora. Tente de novo em instantes.</span>';
        });
    });

    estimativaAutomatica(box);
  }

  function init() {
    document.querySelectorAll('[data-frete]').forEach(ligar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
